var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguagesSmButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 162544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 9552",
    d: "M0 20C0 8.95431 8.95431 0 20 0H60V40H20C8.9543 40 0 31.0457 0 20Z",
    fill: "#34C87C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 162570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.99 10C27.47 10 23 14.48 23 20C23 25.52 27.47 30 32.99 30C38.52 30 43 25.52 43 20C43 14.48 38.52 10 32.99 10ZM39.92 16H36.97C36.65 14.75 36.19 13.55 35.59 12.44C37.43 13.07 38.96 14.35 39.92 16ZM33 12.04C33.83 13.24 34.48 14.57 34.91 16H31.09C31.52 14.57 32.17 13.24 33 12.04ZM25.26 22C25.1 21.36 25 20.69 25 20C25 19.31 25.1 18.64 25.26 18H28.64C28.56 18.66 28.5 19.32 28.5 20C28.5 20.68 28.56 21.34 28.64 22H25.26ZM26.08 24H29.03C29.35 25.25 29.81 26.45 30.41 27.56C28.57 26.93 27.04 25.66 26.08 24ZM29.03 16H26.08C27.04 14.34 28.57 13.07 30.41 12.44C29.81 13.55 29.35 14.75 29.03 16ZM33 27.96C32.17 26.76 31.52 25.43 31.09 24H34.91C34.48 25.43 33.83 26.76 33 27.96ZM35.34 22H30.66C30.57 21.34 30.5 20.68 30.5 20C30.5 19.32 30.57 18.65 30.66 18H35.34C35.43 18.65 35.5 19.32 35.5 20C35.5 20.68 35.43 21.34 35.34 22ZM35.59 27.56C36.19 26.45 36.65 25.25 36.97 24H39.92C38.96 25.65 37.43 26.93 35.59 27.56ZM37.36 22C37.44 21.34 37.5 20.68 37.5 20C37.5 19.32 37.44 18.66 37.36 18H40.74C40.9 18.64 41 19.31 41 20C41 20.69 40.9 21.36 40.74 22H37.36Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagesSmButton);
export default __webpack_public_path__ + "static/media/languagesSmButton.55ff0ddc980be5edb19e1ac6fbd4e6dd.svg";
export { ForwardRef as ReactComponent };